import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Lozenge from '@atlaskit/lozenge';
import type { ThemeAppearance } from '@atlaskit/lozenge';
import type { UpdateType } from '@app/app-updates/src/schema';
import { getStatusMessage, getStatusAppearance, type StatusId } from '@app/app';

const getStatusDisplay = (
  status: NonNullable<UpdateType['status']>,
): [React.ReactNode, ThemeAppearance] => {
  // Check if the status is a known StatusId
  const knownStatuses: StatusId[] = [
    'COMING_SOON',
    'PLANNED',
    'ROLLING_OUT',
    'GENERALLY_AVAILABLE',
    'ROLLED_BACK',
  ];

  if (knownStatuses.includes(status as StatusId)) {
    const statusId = status as StatusId;
    const messageDescriptor = getStatusMessage(statusId);
    const appearance = getStatusAppearance(statusId);

    return [
      <FormattedMessage {...messageDescriptor} key={messageDescriptor.id} />,
      appearance,
    ];
  }

  // Fallback for unknown statuses
  return [status, 'default'];
};

export interface UpdateStatusProps {
  status?: UpdateType['status'];
}

export const UpdateStatus: React.FC<UpdateStatusProps> = ({ status }) => {
  if (!status) {
    return null;
  }

  const [statusMsg, appearance] = getStatusDisplay(status);
  return <Lozenge appearance={appearance}>{statusMsg}</Lozenge>;
};
